import { alpha, Theme } from '@mui/material';
import { useBlendColors } from 'hooks/useDesign';

export default {
    tileElement: {
        //Tile view
        '&.tile-element--view-tile': {
            cursor: 'pointer',
            backgroundColor: (theme: Theme) => theme.componentSettings.tile.bgColor,
            width: (theme: Theme) => theme.size.pxValue(theme.componentSettings.tile.width),
            height: (theme: Theme) => theme.size.pxValue(theme.componentSettings.tile.height),
            border: (theme: Theme) =>
                `${theme.size.pxValue(theme.componentSettings.tile.borderWidth)} solid ${theme.componentSettings.tile.borderColor}`,
            borderRadius: (theme: Theme) => theme.size.pxValue(theme.componentSettings.tile.borderRadius),
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',

            '&:hover': {
                borderColor: (theme: Theme) => theme.componentSettings.tile.hoverBorderColor,
                boxShadow: (theme: Theme) => theme.componentSettings.tile.hoverShadow ?? undefined,
            },

            '&:not(.tile-element--stoplight-default)': {
                borderTopWidth: '3px',
            },
            '&.tile-element--stoplight-good': {
                borderTopColor: (theme: Theme) => theme.componentSettings.tile.stoplight.goodColor,
                '.tile-element__thumbnail-metric-value': {
                    color: (theme: Theme) => theme.componentSettings.tile.stoplight.goodColor,
                },
            },
            '&.tile-element--stoplight-neutral': {
                borderTopColor: (theme: Theme) => theme.componentSettings.tile.stoplight.neutralColor,
                '.tile-element__thumbnail-metric-value': {
                    color: (theme: Theme) => theme.componentSettings.tile.stoplight.neutralColor,
                },
            },
            '&.tile-element--stoplight-bad': {
                borderTopColor: (theme: Theme) => theme.componentSettings.tile.stoplight.badColor,
                '.tile-element__thumbnail-metric-value': {
                    color: (theme: Theme) => theme.componentSettings.tile.stoplight.badColor,
                },
            },

            '.tile-element__header': {
                boxSizing: 'content-box',
                height: '28px',
                position: 'relative',
                padding: '0px 8px',
                display: 'flex',
                alignItems: 'center',
                flexShrink: 0,
                borderBottom: (theme: Theme) => `1px solid ${alpha(theme.componentSettings.tile.borderColor, 0.3)}`,
                backgroundColor: (theme: Theme) => theme.componentSettings.tile.headerBgColor,
                borderTop: (theme: Theme) => `2px solid ${theme.componentSettings.tile.headerBgColor}`,
            },
            '&:not(.tile-element--stoplight-default) .tile-element__header': {
                borderTop: 0,
            },
            '.tile-element__header-left': {
                marginRight: 'auto',
                display: 'flex',
                alignItems: 'center',
                '& > *': { marginRight: '4px' },
            },
            '.tile-element__header-right': {
                marginLeft: 'auto',
                display: 'flex',
                alignItems: 'center',
                '& > *': { marginLeft: '4px' },
            },
            '.tile-element__info': {
                display: 'flex',
            },
            '.tile-element__favorite': {},
            '.tile-element__edit': {},
            '.tile-element__lock': {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '16px',
                display: 'flex',
                color: 'text.primary',
                fontSize: '15px',
            },
            '.tile-element__body': {
                display: 'flex',
                flexGrow: 1,
                padding: '8px',
                position: 'relative',
                overflow: 'hidden',
            },
            '.tile-element__body-image': {
                flexGrow: 1,
                overflow: 'hidden',
            },
            '.tile-element__thumbnail-wrapper': {
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
            '&.tile-element--image-bottom, &.tile-element--image-top': {
                '.tile-element__body': {
                    flexDirection: 'column',
                },
                '.tile-element__name': {
                    height: '36px',
                },
            },
            '&.tile-element--image-left, &.tile-element--image-right': {
                '.tile-element__body-content': {
                    width: '50%',
                    flexShrink: 0,
                    flexDirection: 'column',
                    display: 'flex',
                },
            },
            '.tile-element__name': {
                fontWeight: '600',
                marginBottom: '8px',
                overflow: 'hidden',
                color: (theme: Theme) => theme.componentSettings.tile.titleColor,
            },
            '.tile-element__report-tool-section': {
                position: 'relative',
                fontSize: '10px',
                lineHeight: '20px',
                height: '20px',
            },
            '.tile-element__report-tool-section-icon-text': {
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                color: (theme: Theme) => theme.componentSettings.tile.secondaryTextColor,
            },
            '.tile-element__report-tool-section-expired-label': {
                whiteSpace: 'nowrap',
                color: (theme: Theme) => alpha(theme.componentSettings.tile.secondaryTextColor, 0.6),
            },

            '&.tile-element--image-bottom': {
                '.tile-element__thumbnail-wrapper': {
                    borderTop: (theme: Theme) => `1px solid ${alpha(theme.componentSettings.tile.borderColor, 0.3)}`,
                    paddingTop: '4px',
                },
            },
            '&.tile-element--image-top': {
                '.tile-element__body-image': {
                    order: -1,
                    marginBottom: '4px',
                },
                '.tile-element__thumbnail-wrapper': {
                    borderBottom: (theme: Theme) => `1px solid ${alpha(theme.componentSettings.tile.borderColor, 0.3)}`,
                    paddingBottom: '4px',
                },
            },
            '&.tile-element--image-left': {
                '.tile-element__body-image': {
                    order: -1,
                    marginRight: '8px',
                },
                '.tile-element__thumbnail-wrapper': {
                    borderRight: (theme: Theme) => `1px solid ${alpha(theme.componentSettings.tile.borderColor, 0.3)}`,
                    paddingRight: '8px',
                },
            },
            '&.tile-element--image-right': {
                '.tile-element__body-image': {
                    marginLeft: '8px',
                },
                '.tile-element__thumbnail-wrapper': {
                    borderLeft: (theme: Theme) => `1px solid ${alpha(theme.componentSettings.tile.borderColor, 0.3)}`,
                    paddingLeft: '8px',
                },
            },

            '.tile-element__thumbnail-img': {
                maxWidth: '100%',
                maxHeight: '100%',
                display: 'block',
            },
            '.tile-element__thumbnail-report-rows': {
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                overflow: 'hidden',
                fontSize: '20px',
                lineHeight: 1.2,
                color: (theme: Theme) => theme.componentSettings.tile.secondaryTextColor,
            },
            '.tile-element__thumbnail-report-rows-text': {
                maxWidth: '100%',
            },
            '.tile-element__thumbnail-report-rows-count': {},
            '.tile-element__thumbnail-report-rows-label': {
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                maxWidth: '100%',
                display: 'inline-block',
                verticalAlign: 'text-top',
            },
            '.tile-element__thumbnail-metric': {
                textAlign: 'right',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
            },
            '.tile-element__thumbnail-metric-image': {
                flexGrow: 1,
                overflow: 'hidden',
                '& img': {
                    maxWidth: '100%',
                    maxHeight: '100%',
                    display: 'block',
                },
            },
            '.tile-element__thumbnail-metric-ptc-variance': {
                color: (theme: Theme) => theme.componentSettings.tile.secondaryTextColor,
                fontSize: '10px',
                lineHeight: 1.2,
                minHeight: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
            },
            '.tile-element__thumbnail-metric-value': {
                mt: '4px',
                fontWeight: 600,
                color: (theme: Theme) => theme.palette.text.primary,
                fontSize: '22px',
                lineHeight: '24px',
            },
        },

        //List view
        '&.tile-element--view-list': {
            height: '59px',
            cursor: 'pointer',
            backgroundColor: 'background.default',
            width: '100%',
            padding: '8px 0',
            display: 'flex',
            borderBottom: (theme: Theme) => `1px solid ${useBlendColors(alpha(theme.palette.text.primary, 0.08))}`,

            '.tile-element__thumbnail-wrapper': {
                width: '76px',
                paddingLeft: '12px',
                flexShrink: 0,
                display: 'flex',
                alignItems: 'flex-start',
            },
            '.tile-element__thumbnail-img': {
                maxWidth: '100%',
                maxHeight: '100%',
                display: 'block',
            },
            '.tile-element__thumbnail-report-rows': {
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                overflow: 'hidden',
                fontSize: '13px',
                lineHeight: 1.2,
                color: (theme: Theme) => alpha(theme.palette.text.primary, 0.75),
            },
            '.tile-element__thumbnail-report-rows-text': {
                maxWidth: '100%',
            },
            '.tile-element__thumbnail-report-rows-count': {
                display: 'block',
            },
            '.tile-element__thumbnail-report-rows-label': {
                display: 'block',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
            },
            '.tile-element__name': {
                paddingLeft: '12px',
                flexGrow: 1,
                color: 'primary.main',
            },
            '.tile-element__report-tool-section': {
                paddingLeft: '12px',
                width: '300px',
            },
            '.tile-element__icons-holder': {
                flexShrink: 0,
                paddingLeft: '4px',
                display: 'flex',
                alignItems: 'flex-start',

                '&>*': {
                    marginLeft: '8px',
                },
            },
        },

        //Multi list view
        '&.tile-element--view-multi-list': {
            display: 'flex',
            cursor: 'pointer !important',
            p: 1,
            position: 'relative',
            '&:hover, &.state--hover': {
                backgroundColor: (theme: Theme) => useBlendColors(alpha(theme.palette.text.primary, 0.03)),
            },

            '.tile-element__name': {
                flexGrow: 1,
            },
            '&.tile-element--lock .tile-element__name, &.tile-element--certified .tile-element__name': {
                pr: 3, //icon+margin
            },
            '&.tile-element--lock.tile-element--certified .tile-element__name': {
                pr: 6, //2 icons + 2 margins
            },
            '.icons-holder': {
                display: 'flex',
                alignItems: 'center',
                height: '18px',
                position: 'absolute',
                right: '8px',
                '&>*': {
                    ml: 1,
                    display: 'none',
                },
            },
            '.always-show--lock .tile-list-section & .tile-element__lock': {
                display: 'inline-flex',
            },
            '.always-show--certification .tile-list-section & .tile-element__info--certified': {
                display: 'inline-flex',
            },
            '&:hover .icons-holder, &.state--hover .icons-holder': {
                backgroundColor: (theme: Theme) => useBlendColors(alpha(theme.palette.text.primary, 0.03)),
                '&>*': {
                    display: 'inline-flex',
                },
                '&:before': {
                    content: "''",
                    position: 'absolute',
                    inset: '0 100% 0 auto',
                    width: '16px',
                    backgroundImage: (theme: Theme) =>
                        `linear-gradient(90deg, ${alpha(useBlendColors(alpha(theme.palette.text.primary, 0.03)), 0)} 0%, ${useBlendColors(alpha(theme.palette.text.primary, 0.03))} 100%)`,
                },
            },
            '.tile-element__lock': {
                color: 'primary.main',
            },
            '.tile-element__edit:hover': {
                color: 'primary.main',
            },
        },
    },
};
